export default __webpack_public_path__ + "static/media/love-heart-pin.adbb86f2.svg";